/* eslint-disable import/no-anonymous-default-export */
import axiosInstance from "../axios/axios-configuration";
import { CancelToken } from "axios";
import { IArubaRemoteSignRequest, ICreateAllocatedProtocolRequest, ICreateDraftFromPecMailRequest, ICreateProtocol, IField, IFile, IGetProtocolsResult, ILabelInfo, ILog, IMailPecMail, IProtocol, IProtocolsRequest, ITitolario, IVisibilita } from "../shared/interfaces";
import { Protocol_Type } from "../shared/enums";




const getProtocolsAsStream = (aooId: number, protocolsRequest: IProtocolsRequest, cancelToken?: CancelToken): Promise<IGetProtocolsResult> => {
    return axiosInstance.post(`Protocols/${aooId}/GetProtocolsAsStream`, protocolsRequest, { cancelToken: cancelToken })
        .then(result => result.data)
        .catch(error => {
            return Promise.reject(error);
        });
}

const getProtocol = (aooId: number, uorId: number | undefined, protocolId: number, cancelToken?: CancelToken): Promise<any> => {
    return axiosInstance.get(`Protocols/${aooId}/GetProtocol/${protocolId}`, { params: { uorId: uorId }, cancelToken: cancelToken })
        .then(result => result.data)
        .catch(error => {
            return Promise.reject(error);
        });
}

const getVisibilitaProtocollo = (aooId: number, protocolId: number, cancelToken?: CancelToken): Promise<IVisibilita[]> => {
    return axiosInstance.get(`Protocols/${aooId}/GetVisibilitaProtocollo/${protocolId}`, { cancelToken: cancelToken })
        .then(result => result.data)
        .catch(error => {
            return Promise.reject(error);
        });
}

const getUserVisibilitaForProtocol = (aooId: number, protocolId: number, cancelToken?: CancelToken): Promise<IVisibilita[]> => {
    return axiosInstance.get(`Protocols/${aooId}/GetUserVisibilitaForProtocol/${protocolId}`, { cancelToken: cancelToken })
        .then(result => result.data)
        .catch(error => {
            return Promise.reject(error);
        });
}


const getProtocolVisibilityFromForwardRules = (aooId: number, protocol: IProtocol, cancelToken?: CancelToken): Promise<IVisibilita[]> => {
    return axiosInstance.post(`Protocols/${aooId}/GetProtocolVisibilityFromForwardRules`, protocol, { cancelToken: cancelToken })
        .then(result => result.data)
        .catch(error => {
            return Promise.reject(error);
        });
}

const getProtocolBase64String = (aooId: number, uorId: number | undefined, protocolId: number, cancelToken?: CancelToken): Promise<IFile> => {

    return axiosInstance.get(`Protocols/${aooId}/GetProtocolBase64/${protocolId}`, { params: { uorId: uorId }, cancelToken: cancelToken })
        .then(result => result.data)
        .catch(error => {
            return Promise.reject(error);
        });
}

const getAttachmentBase64String = (aooId: number, uorId: number | undefined, protocolId: number, filename: string, cancelToken?: CancelToken): Promise<IFile> => {

    return axiosInstance.get(`Protocols/${aooId}/GetFileBase64/${protocolId}`, { params: { uorId: uorId, filename: filename }, cancelToken: cancelToken })
        .then(result => result.data)
        .catch(error => {
            return Promise.reject(error);
        });
}

const getFileSPById = (aooId: number, uorId: number | undefined, protocolId: number, fileId: number, cancelToken?: CancelToken): Promise<IFile> => {

    return axiosInstance.get(`Protocols/${aooId}/GetFileSPById/${protocolId}/${fileId}`, { params: { uorId: uorId }, cancelToken: cancelToken })
        .then(result => result.data)
        .catch(error => {
            return Promise.reject(error);
        });
}

const getProtocolFilesAsZip = (aooId: number, uorId: number | undefined, protocolId: number, cancelToken?: CancelToken): Promise<IFile> => {
    return axiosInstance.get(`Protocols/${aooId}/GetProtocolFilesAsZip/${protocolId}`, { params: { uorId: uorId }, cancelToken: cancelToken })
        .then(result => result.data)
        .catch(error => {
            return Promise.reject(error);
        });
}

const getAudit = (aooId: number, uorId: number | undefined, protocolId: number, cancelToken?: CancelToken): Promise<ILog[]> => {

    return axiosInstance.get(`Protocols/${aooId}/GetAudit/${protocolId}`, { params: { uorId: uorId }, cancelToken: cancelToken })
        .then(result => result.data)
        .catch(error => {
            return Promise.reject(error);
        });
}

const addAttachment = (aooId: number, uorId: number, protocolId: number, attach: IFile, cancelToken?: CancelToken): Promise<number> => {

    return axiosInstance.post(`Protocols/${aooId}/${uorId}/AddAttachment/${protocolId}`, attach, { cancelToken: cancelToken })
        .then(result => result.data)
        .catch(error => {
            return Promise.reject(error);
        });
}

const deleteAttachment = (aooId: number, uorId: number, protocolId: number, attachId: number, cancelToken?: CancelToken): Promise<number> => {

    return axiosInstance.delete(`Protocols/${aooId}/${uorId}/DeleteAttachment/${protocolId}/${attachId}`, { cancelToken: cancelToken })
        .then(result => result.data)
        .catch(error => {
            return Promise.reject(error);
        });
}

const createProtocol = (aooId: number, uorId: number, protocol: IProtocol, labelInfo: ILabelInfo, cancelToken?: CancelToken): Promise<any> => {
    const createProtocolObj: ICreateProtocol = { protocolSP: protocol, labelInfo: labelInfo };
    return axiosInstance.post(`Protocols/${aooId}/${uorId}/CreateProtocol`, createProtocolObj, { cancelToken: cancelToken })
        .then(result => result.data)
        .catch(error => {
            return Promise.reject(error);
        });
}

const createProtocolFromDraft = (aooId: number, uorId: number, protocol: IProtocol, labelInfo: ILabelInfo, cancelToken?: CancelToken): Promise<any> => {
    const createProtocolObj: ICreateProtocol = { protocolSP: protocol, labelInfo: labelInfo };
    return axiosInstance.post(`Protocols/${aooId}/${uorId}/CreateProtocolFromDraft`, createProtocolObj, { cancelToken: cancelToken })
        .then(result => result.data)
        .catch(error => {
            return Promise.reject(error);
        });
}

const createDraft = (aooId: number, uorId: number, protocol: IProtocol, cancelToken?: CancelToken): Promise<any> => {
    return axiosInstance.post(`Protocols/${aooId}/${uorId}/CreateDraft`, protocol, { cancelToken: cancelToken })
        .then(result => result.data)
        .catch(error => {
            return Promise.reject(error);
        });
}

const createDraftFromPecMail = (aooId: number, uorId: number, createDraftFromPecMailRequest: ICreateDraftFromPecMailRequest, cancelToken?: CancelToken): Promise<any> => {
    return axiosInstance.post(`Protocols/${aooId}/${uorId}/CreateDraftFromPecMail`, createDraftFromPecMailRequest, { cancelToken: cancelToken })
        .then(result => result.data)
        .catch(error => {
            return Promise.reject(error);
        });
}

const deleteDraft = (aooId: number, uorId: number, protId: number, cancelToken?: CancelToken): Promise<any> => {
    return axiosInstance.delete(`Protocols/${aooId}/${uorId}/DeleteDraft/${protId}`, { cancelToken: cancelToken })
        .then(result => result.data)
        .catch(error => {
            return Promise.reject(error);
        });
}

const reloadProtocol = (aooId: number, uorId: number, protocol: IProtocol, labelInfo: ILabelInfo, cancelToken?: CancelToken): Promise<any> => {
    const reloadProtocolObj: ICreateProtocol = { protocolSP: protocol, labelInfo: labelInfo };
    return axiosInstance.post(`Protocols/${aooId}/${uorId}/ReloadProtocol`, reloadProtocolObj, { cancelToken: cancelToken })
        .then(result => result.data)
        .catch(error => {
            return Promise.reject(error);
        });
}

const updateProtocol = (aooId: number, uorId: number, protocolId: number, fields: IField[], cancelToken?: CancelToken): Promise<any> => {
    return axiosInstance.post(`Protocols/${aooId}/${uorId}/UpdateProtocol/${protocolId}`, fields, { cancelToken: cancelToken })
        .then(result => result.data)
        .catch(error => {
            return Promise.reject(error);
        });
}

const updateProtocolDraft = (aooId: number, uorId: number, protocolId: number, protocol: IProtocol, cancelToken?: CancelToken): Promise<any> => {
    return axiosInstance.post(`Protocols/${aooId}/${uorId}/UpdateProtocolDraft/${protocolId}`, protocol, { cancelToken: cancelToken })
        .then(result => result.data)
        .catch(error => {
            return Promise.reject(error);
        });
}

const updateFilingPlanProtocol = (aooId: number, uorId: number, protocolId: number, titolario?: string, cancelToken?: CancelToken): Promise<any> => {
    return axiosInstance.put(`Protocols/${aooId}/${uorId}/UpdateFilingPlanProtocol/${protocolId}`, undefined, { params: { titolario }, cancelToken: cancelToken })
        .then(result => result.data)
        .catch(error => {
            return Promise.reject(error);
        });
}

const updateVisibilitaProtocol = (aooId: number, uorId: number, protocolId: number, visibilita: IVisibilita[], cancelToken?: CancelToken): Promise<any> => {
    return axiosInstance.post(`Protocols/${aooId}/${uorId}/UpdateVisibilitaProtocol/${protocolId}`, visibilita, { cancelToken: cancelToken })
        .then(result => result.data)
        .catch(error => {
            return Promise.reject(error);
        });
}

const protocolla = (aooId: number, uorId: number, protocolId: number, cancelToken?: CancelToken): Promise<number> => {

    return axiosInstance.post(`Protocols/${aooId}/${uorId}/Protocolla/${protocolId}`, null, { cancelToken: cancelToken })
        .then(result => result.data)
        .catch(error => {
            return Promise.reject(error);
        });
}

const undoProtocol = (aooId: number, uorId: number, protocolId: number, cancelToken?: CancelToken): Promise<number> => {

    return axiosInstance.post(`Protocols/${aooId}/${uorId}/Undo/${protocolId}`, null, { cancelToken: cancelToken })
        .then(result => result.data)
        .catch(error => {
            return Promise.reject(error);
        });
}

const signDocumentPades = (aooId: number, uorId: number, protId: number, arubaRemoteSignRequest: Partial<IArubaRemoteSignRequest>, cancelToken?: CancelToken): Promise<any> => {
    return axiosInstance.post(`Protocols/${aooId}/${uorId}/SignDocumentPades/${protId}`, arubaRemoteSignRequest, { cancelToken: cancelToken })
        .then(result => result.data)
        .catch(error => {
            return Promise.reject(error);
        });
}

const updateAcquired = (aooId: number, uorId: number, protocol: IProtocol, labelInfo: ILabelInfo, cancelToken?: CancelToken): Promise<any> => {
    const updateAcquiredObject: ICreateProtocol = { protocolSP: protocol, labelInfo: labelInfo };
    return axiosInstance.post(`Protocols/${aooId}/${uorId}/UpdateAcquired`, updateAcquiredObject, { cancelToken: cancelToken })
        .then(result => result.data)
        .catch(error => {
            return Promise.reject(error);
        });
}

const protocollaAcquired = (aooId: number, uorId: number, protocol: IProtocol, labelInfo: ILabelInfo, cancelToken?: CancelToken): Promise<number> => {
    const protocollaAcquiredObject: ICreateProtocol = { protocolSP: protocol, labelInfo: labelInfo };
    return axiosInstance.post(`Protocols/${aooId}/${uorId}/ProtocollaAcquired/${protocol.id}`, protocollaAcquiredObject, { cancelToken: cancelToken })
        .then(result => result.data)
        .catch(error => {
            return Promise.reject(error);
        });
}

const createAllocatedProtocol = (aooId: number, uorId: number, protocol: IProtocol,  cancelToken?: CancelToken): Promise<any> => {
    const createAllocatedProtocolRequest: ICreateAllocatedProtocolRequest =
    {
        attachments: protocol.attachments ? [...protocol.attachments] : [],
        fields: protocol.fields ? [...protocol.fields] : [],
        tipoProtocollo: protocol.tipoProtocollo ? protocol.tipoProtocollo : Protocol_Type.Undefined,
        titolario: protocol.titolario,
    };
    return axiosInstance.post(`Protocols/${aooId}/${uorId}/CreateAllocatedProtocol`, createAllocatedProtocolRequest, { cancelToken: cancelToken })
        .then(result => result.data)
        .catch(error => {
            return Promise.reject(error);
        });
}

const protocollaOAcquisisciAllocato = (aooId: number, uorId: number, protocol: IProtocol, cancelToken?: CancelToken): Promise<any> => {
    return axiosInstance.post(`Protocols/${aooId}/${uorId}/ProtocollaOAcquisisciAllocato/${protocol.id}`, protocol, { cancelToken: cancelToken })
        .then(result => result.data)
        .catch(error => {
            return Promise.reject(error);
        });
}

const getSignatureForProtocol = (aooId: number, uorId: number, protocolId: number, cancelToken?: CancelToken): Promise<any> => {
    return axiosInstance.get(`Protocols/${aooId}/${uorId}/GetSignatureForProtocol/${protocolId}`, { cancelToken: cancelToken })
        .then(result => result.data)
        .catch(error => {
            return Promise.reject(error);
        });
}



export default {
    getProtocolsAsStream,
    getProtocol,
    getVisibilitaProtocollo,
    getUserVisibilitaForProtocol,
    getProtocolVisibilityFromForwardRules,
    getProtocolBase64String,
    getAttachmentBase64String,
    getFileSPById,
    getProtocolFilesAsZip,
    getAudit,
    addAttachment,
    deleteAttachment,
    createProtocol,
    createProtocolFromDraft,
    createDraft,
    createDraftFromPecMail,
    deleteDraft,
    reloadProtocol,
    updateProtocol,
    updateProtocolDraft,
    updateFilingPlanProtocol,
    updateVisibilitaProtocol,
    protocolla,
    undoProtocol,
    signDocumentPades,
    updateAcquired,
    protocollaAcquired,
    createAllocatedProtocol,
    protocollaOAcquisisciAllocato,
    getSignatureForProtocol
}

